import AOS from 'aos';

AOS.init({
  disable: 'phone',
});
